import Vue from 'vue';

export default Vue.component('ed-chip', { 
  name: 'ed-chip',
  props: {
    value: {
      type: [String, Number, Object],
      required: true,
    },
    toggleChip: {
      type: Function,
      required: true,
    },
    selectedValue: {
      type: [String, Number, Object],
      required: false,
    },
  },
  computed: {
    isSelected() {
      return this.selectedValue === this.value;
    },
  },
  methods: {
    handleClick() {
      this.toggleChip(this.value);
    },
  },
});